let modelsCompareSwiper;
let isModelsCompareMobile = $(window).outerWidth() < 768;

const initModelsCompareSwiper = () => {
  modelsCompareSwiper = new Swiper('.models-compare__inner', {
    slidesPerView: 'auto'
  });
};

const destroyModelsCompareSwiper = () => {
  modelsCompareSwiper && modelsCompareSwiper.destroy();
};

if (!isModelsCompareMobile) {
  initModelsCompareSwiper();
};

$(window).on('resize', function() {
  if ($(window).outerWidth() > 767 && isModelsCompareMobile) {
    initModelsCompareSwiper();
    isModelsCompareMobile = false;
  }

  if ($(window).outerWidth() < 768 && !isModelsCompareMobile) {
    destroyModelsCompareSwiper();
    isModelsCompareMobile = true;
  }
});
